import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { Atividade } from 'src/app/core/atividade';
import { TiposAtividades } from 'src/app/core/tipos-atividades';
import { Unidade } from 'src/app/core/unidade';
import { TiposAtividadesService } from 'src/app/services/tipos-atividades/tipos-atividades.service';
import { ToolbarPrincipalService } from 'src/app/services/toolbarPrincipal/toolbar-principal.service';
import { UnidadeService } from 'src/app/services/unidade/unidade.service';
import { Acesso } from "../../../core/acesso";
import { Objetivo } from "../../../core/objetivo";
import { ObjetivoAtividade } from "../../../core/objetivo-atividade";
import { DataUtilService } from "../../../services/commons/data-util.service";
import { ComboProgramaComponent } from '../../common/combo-programa/combo-programa.component';
import { ComboProjetoComponent } from '../../common/combo-projeto/combo-projeto.component';

@Component({
  selector: 'dados-atividade',
  templateUrl: './dados-atividade.component.html',
  styleUrls: ['./dados-atividade.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class DadosAtividadeComponent implements OnInit, OnChanges {
  public mascaraHorario = [/\d/, /\d/, ':', /[0-5]/, /\d/];

  @Input() atividade: Atividade;
  @Input() perfilAcesso: Acesso;

  @ViewChild('comboProgramaPorContrato', { static: false })
  comboProgramaPorContrato: ComboProgramaComponent;

  @ViewChild('comboProjetoPorContrato', { static: false })
  comboProjetoPorContrato: ComboProjetoComponent;

  unidades: Unidade[];

  tipoHorario: any = [
    { id: 'F', descricao: 'FIXO' },
    { id: 'L', descricao: 'LIVRE' },
  ];

  localExecucao: any = [
    { id: 'I', descricao: 'INTERNA' },
    { id: 'E', descricao: 'EXTERNA' },
  ];

  mostrarCampos = false;
  tiposAtividades: TiposAtividades[];

  constructor(
    private toolbarPrincipalService: ToolbarPrincipalService,
    private tiposAtividadesService: TiposAtividadesService,
    private unidadeService: UnidadeService,
    private activatedRoute: ActivatedRoute,
    private dataUtilService: DataUtilService,
    private cdr: ChangeDetectorRef
    ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['atividade'] && changes['atividade'].currentValue) {
      if(this.atividade && this.atividade.tiposAtividades.id){
        this.atividade.tiposAtividades = _.find(this.tiposAtividades, (u: TiposAtividades) => u.id === this.atividade.tiposAtividades.id);        
      }
      this.cdr.detectChanges();
    }
  }

  ngOnInit() {
    this.mostrarCampos = false;

    this.unidadeService.getAllUnidadesUsuarioLogadoTemAcesso().subscribe((unidades: Unidade[]) => {
      this.unidades = unidades;
      if(!this.atividade.unidade.idUnidade){
        this.atividade.unidade = _.find(this.unidades, (u: Unidade) => u.idUnidade === this.toolbarPrincipalService.getUnidadeLogada().id);
      }
    });

    this.tiposAtividadesService.getAll().subscribe((tiposAtividades: TiposAtividades[]) => {
      this.tiposAtividades = tiposAtividades;
    });

  }

  onValorChangePrograma(registro: any) {
    this.atividade.programa = registro;
  }

  onValorChangeProjeto(registro: any) {
    this.atividade.projeto = registro;
  }

  onValorChangePercurso(registro: any) {
    this.atividade.percurso = registro;
  }

  addObjetivoAtividade() {
    if (!this.atividade.objetivosAtividade)
      this.atividade.objetivosAtividade = [];

    const objetivoAtividade: ObjetivoAtividade = new ObjetivoAtividade();
    objetivoAtividade.id = undefined;
    objetivoAtividade.objetivo = new Objetivo();
    this.atividade.objetivosAtividade.push(objetivoAtividade);
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

  formatarCargaHoraria(): void {
    if (this.atividade && this.atividade.cargaHoraria != null) {
      this.atividade.cargaHoraria = parseFloat(this.atividade.cargaHoraria.toFixed(2));
    }
  }  

  atualizarCargaHoraria(valor: string): void {
    const valorNumerico = parseFloat(valor);
    if (!isNaN(valorNumerico)) {
      this.atividade.cargaHoraria = parseFloat(valorNumerico.toFixed(2));
    } else {
      this.atividade.cargaHoraria = null;
    }
  }  

  onTimeChange(value: string) {
    if (!value) {
      this.atividade.cargaHoraria = null;
      return;
    }
  
    const [hh, mm] = value.split(':').map(Number);
  
    if (!isNaN(hh) && !isNaN(mm) && mm >= 0 && mm < 60) {
      this.atividade.cargaHoraria = hh + mm / 60;
    }
  }

  onValorChangeContrato(selecionado: any): void {
    const previousContrato = this.atividade.contrato;
    this.atividade.contrato = selecionado;
  
    if (this.comboProgramaPorContrato) {
      this.comboProgramaPorContrato.contrato = selecionado; 
      this.comboProgramaPorContrato.ngOnChanges({
        contrato: {
          currentValue: selecionado,
          previousValue: previousContrato,
          firstChange: previousContrato == null,
          isFirstChange: () => previousContrato == null,
        }
      });
    }

    if (this.comboProjetoPorContrato) {
      this.comboProjetoPorContrato.contrato = selecionado; 
      this.comboProjetoPorContrato.ngOnChanges({
        contrato: {
          currentValue: selecionado,
          previousValue: previousContrato,
          firstChange: previousContrato == null,
          isFirstChange: () => previousContrato == null,
        }
      });
    }
  }

}
